import {
  and,
  ControlProps,
  RankedTester,
  rankWith,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";
import { RenderersUIType } from "@home-health-notify/domain";

const InputWithAdornmentViewRenderer = ({
  data,
  label,
  uischema,
}: ControlProps) => {
  const { suffix } = uischema.options || {};
  const value = suffix ? `${data}${suffix}` : data;
  return (
    <FormDetailWrapper data-testid="form-content-item">
      <FormDetailItem>{label} :</FormDetailItem>
      <FormDetailValue>{data ? value : "N/A"}</FormDetailValue>
    </FormDetailWrapper>
  );
};

export const inputWithAdornmentViewTester: RankedTester = rankWith(
  5,
  and(uiTypeIs(RenderersUIType.InputWithAdornment)),
);

export default withJsonFormsControlProps(InputWithAdornmentViewRenderer);
